<!-- location ma -->
<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data () {
    return {
    };
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>

</style>
